/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadybadgecopy3Inputs */

const en_searchreadybadgecopy3 = /** @type {(inputs: Searchreadybadgecopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy code`)
};

const de_searchreadybadgecopy3 = /** @type {(inputs: Searchreadybadgecopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code kopieren`)
};

/**
* | output |
* | --- |
* | "Copy code" |
*
* @param {Searchreadybadgecopy3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadybadgecopy3 = /** @type {((inputs?: Searchreadybadgecopy3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadybadgecopy3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadybadgecopy3(inputs)
	return de_searchreadybadgecopy3(inputs)
});
export { searchreadybadgecopy3 as "searchReadyBadgeCopy" }